import { getAppTitle } from '@/shared/utils/documentTitle';

document.title = getAppTitle();

import('./bootstrap');
